export default "__VITE_ASSET__BHKG8i1A__"